import styled, { css } from "styled-components"

import { color } from "../../../atoms/colors"

export const Section = styled.section`
  padding: 96px 0;
  background: linear-gradient(
    103.16deg,
    ${color.common.gradientBlue} -0.76%,
    ${color.oxfordBlue[900]} 52.98%
  );
  ${(props) =>
    props?.background && props?.background === "light"
      ? css`
          background: ${color.aliceBlue[50]};
        `
      : props?.background === "lightgradient"
      ? css`
          background: linear-gradient(
              180deg,
              ${color.common.white} 71.87%,
              rgba(255, 255, 255, 0) 99.99%,
              rgba(0, 0, 0, 0) 100%
            ),
            linear-gradient(
              250.72deg,
              #abe2f4 -8.68%,
              #f0f7e9 62.92%,
              #edfbff 117.43%
            ),
            ${color.daveysGray[25]};
        `
      : props?.background === "white"
      ? css`
          background: ${color.common.white};
        `
      : css`
          background: linear-gradient(
            103.16deg,
            ${color.common.gradientBlue} -0.76%,
            ${color.oxfordBlue[900]} 52.98%
          );
        `}
  @media (max-width: 992px) {
    padding: 56px 0;
  }
  @media (max-width: 576px) {
    padding: 40px 0;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1230px;
  margin: 0 auto;
  padding: 0px 30px;
  @media (max-width: 992px) {
    max-width: 830px;
  }
  @media (max-width: 576px) {
    max-width: 566px;
  }
`

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 770px;
  margin: 0px auto 64px;
  @media (max-width: 992px) {
    margin: 0px auto 48px;
  }
  @media (max-width: 576px) {
    margin: 0px auto 40px;
  }
`

export const Heading = styled.h2`
  font-weight: 800;
  font-size: 48px;
  line-height: 60px;
  text-align: center;
  letter-spacing: -0.02em;
  color: ${color.common.white};
  margin-bottom: 16px;
  ${(props) =>
    props?.background &&
    (props?.background === "white" ||
      props?.background === "lightgradient" ||
      props?.background === "light") &&
    css`
      color: ${color.oxfordBlue[900]};
    `}
  @media (max-width: 576px) {
    font-size: 36px;
    line-height: 44px;
    text-align: center;
    letter-spacing: -0.02em;
  }
`

export const Subhead = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${color.copy[200]};
  ${(props) =>
    props?.background &&
    (props?.background === "white" ||
      props?.background === "lightgradient" ||
      props?.background === "light") &&
    css`
      color: ${color.copy[700]};
    `}
`

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    width: 100%;
  }
  .note {
    margin-top: 24px;
    color: ${color.copy[200]};
    ${(props) =>
      props?.background &&
      (props?.background === "white" ||
        props?.background === "lightgradient" ||
        props?.background === "light") &&
      css`
        color: ${color.copy[700]};
      `}
    font-weight: 350;
    font-size: 16px;
    line-height: 24px;
    a {
      color: ${color.primary[200]};
      transition: all 450ms ease-in-out 0s;
      &.arrow-link {
        position: relative;
        text-decoration: none;
        font-weight: 850;
        font-size: 18px;
        line-height: 24px;
        padding-right: 15px;
        top: 8px;
        cursor: pointer;
        &:hover {
          color: ${color.logoBlue[200]};
        }
        &:before,
        &:after {
          border-right: 2px solid;
          content: "";
          display: block;
          height: 8px;
          margin-top: -6px;
          position: absolute;
          transform: rotate(135deg);
          right: 0;
          top: 54%;
          width: 0;
        }
        :after {
          margin-top: -1px;
          transform: rotate(45deg);
        }
      }
    }
  }
  table {
    border-radius: 24px;
    border-spacing: 0;
    text-align: center;
    width: 100%;
    border-collapse: separate !important;
    border-spacing: 0;
    border-color: ${color.common.transparent};
    th {
      padding: 24px 0px;
      border: 1px solid ${color.logoBlue[400]};
      ${(props) =>
        props?.noBorder &&
        css`
          border: none;
        `}
    }
    tr:first-child {
      th:first-child {
        border-top-left-radius: 24px;
        border-top-right-radius: 24px;
      }
    }
    tr:last-child {
      td:first-child {
        border-bottom-left-radius: 24px;
      }
    }

    tr:last-child {
      td:last-child {
        border-bottom-right-radius: 24px;
      }
    }
    td {
      padding: 24px 0px;
      border: 0.5px solid ${color.logoBlue[400]};
      ${(props) =>
        props?.noBorder &&
        css`
          border: none;
        `}
      font-weight: 500;
    }
    h1 > span {
      font-weight: 900 !important;
      color: ${color.oxfordBlue[900]} !important;
      font-size: 48px !important;
      line-height: 60px !important;
      @media (max-width: 992px) {
        font-size: 36px !important;
        line-height: 44px !important;
      }
    }
    h2 > span {
      font-weight: 900 !important;
      color: ${color.oxfordBlue[900]} !important;
      font-size: 36px !important;
      line-height: 44px !important;
      @media (max-width: 992px) {
        font-size: 30px !important;
        line-height: 38px !important;
      }
    }
    h3 > span {
      font-weight: 900 !important;
      color: ${color.oxfordBlue[900]} !important;
      font-size: 30px !important;
      line-height: 38px !important;
      margin-bottom: 0px !important;
      @media (max-width: 992px) {
        font-weight: 900 !important;
        font-size: 24px !important;
        line-height: 32px !important;
      }
      @media (max-width: 576px) {
        font-size: 20px !important;
        line-height: 30px !important;
      }
    }
    h4 > span {
      font-weight: 900 !important;
      color: ${color.oxfordBlue[900]} !important;
      font-size: 20px !important;
      line-height: 30px !important;
      margin-bottom: 0px !important;
      @media (max-width: 992px) {
        font-size: 18px !important;
        line-height: 24px !important;
      }
    }
    p {
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 0px;
      color: ${color.common.white};
      ${(props) =>
        props?.background &&
        (props?.background === "white" ||
          props?.background === "lightgradient" ||
          props?.background === "light") &&
        css`
          color: ${color.copy[700]};
        `}
      @media (max-width: 992px) {
        font-size: 18px;
        line-height: 24px;
      }
    }
    a {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: ${color.primary[700]};
      text-decoration: none;
      padding-right: 15px;
      position: relative;
      transition: all 450ms ease-in-out 0s;
      :hover {
        color: ${color.logoBlue[200]};
      }
      &:before,
      &:after {
        border-right: 2px solid;
        content: "";
        display: block;
        height: 8px;
        margin-top: -6px;
        position: absolute;
        transform: rotate(135deg);
        right: 0px;
        top: 54%;
        width: 0;
      }
      :after {
        margin-top: -1px;
        transform: rotate(45deg);
      }
    }
  }
`
